<template>
  <div
    v-if="
      ['home', 'newPassword', 'error404', 'launch'].indexOf($route.name) == -1
    "
  >
    <v-footer dark style="background-color: #4b2a66" class="ma-0 pa-0">
      <v-card class="transparent" tile flat style="width: 100%">
        <div class="d-flex align-center justify-space-between px-1">
          <div
            class="text-h4 font-weight-medium d-flex"
            v-if="$vuetify.breakpoint.xs"
          >
            <v-img src="@/assets/logo-text-white.svg" width="100px" />
          </div>
          <div class="text-h4 pb-3 font-weight-medium d-flex" v-else>
            <v-img src="@/assets/logo-white.svg" width="170px" />
          </div>
          <div class="mx-10 d-flex align-end">
            <div
              class="font-weight-light text-h6"
              v-if="!$vuetify.breakpoint.xs"
            >
              Siga-nos:
            </div>
            <div class="d-flex">
              <v-col
                v-for="(icon, i) in icons"
                :key="i"
                style="flex-grow: 0"
                class="py-0 px-1"
              >
                <v-tooltip class="black" top>
                  {{ icon.text }}
                  <template #activator="{ on }">
                    <v-btn dark icon :href="icon.ref" target="_blank" v-on="on">
                      <v-icon
                        :size="$vuetify.breakpoint.xs ? '20px' : '24px'"
                        >{{ icon.icon }}</v-icon
                      >
                    </v-btn>
                  </template>
                </v-tooltip>
              </v-col>
            </div>
          </div>

          <div :class="$vuetify.breakpoint.xs ? 'ml-n5' : ''">
            <v-btn
              :x-small="$vuetify.breakpoint.xs"
              @click="contactDialog = true"
              >Contate-nos</v-btn
            >
          </div>
        </div>
        <!--<div class="text-subtitle-1 font-weight-bold">Sobre nós</div>
            <div class="text-justify">
              O Olhadela é a sua Vitrine Virtual, desenvolvido exclusivamente
              para que Empresas, de todos os tamanhos, possam divulgar o seu
              negócio, e para que pessoas possam encontrar Produtos/Serviços
              próximos da sua localização.
            </div>-->
        <!--<v-col md="4" cols="8" class="pl-10">
            <p class="text-h6 pr-4 ma-0 pa-0">Mais Informações</p>
            <v-list class="transparent ma-0 pa-0">
              <v-list-item-group>
                <v-list-item
                  v-for="(item, i) in items"
                  :key="i"
                  dense
                  :to="item.link"
                >
                  <v-list-item-content class="ma-0 pa-0">
                    <v-list-item-title>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>-->

        <v-dialog v-model="contactDialog" max-width="600">
          <v-card class="pa-2">
            <v-card-title class="d-flex align-center justify-space-between"
              >Contate-nos
              <v-btn icon @click="contactDialog = false"
                ><v-icon color="black">mdi-close</v-icon></v-btn
              >
            </v-card-title>
            <v-card-text>
              <v-form ref="contactForm">
                <v-text-field
                  v-model="email"
                  :rules="[$rules.required, $rules.email]"
                  required
                  outlined
                  :disabled="loading"
                  label="Seu email *"
                  class="mb-3"
                  hide-details="auto"
                />
                <v-textarea
                  v-model="message"
                  :rules="[$rules.required]"
                  required
                  outlined
                  hide-details="auto"
                  :disabled="loading"
                  label="Mensagem *"
                  rows="3"
                  auto-grow
                />
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    @click="
                      sendMessage();
                      contactMessage = true;
                    "
                    color="#4B2A66"
                    dark
                    :loading="loading"
                  >
                    Enviar
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="contactMessage" max-width="600">
          <v-card class="pa-2" align="center">
            <v-card-text class="black--text mt-2">
              <div class="text-h5">Seu contato foi enviado!</div>
            </v-card-text>
            <v-card-text>
              <div class="text-subtitle-2 grey--text text--darken-3">
                A Equipe do Olhadela irá responder em breve. Se lhe auxiliar,
                acesse nossa Página de Suporte
                <a style="color: #4b2a66" href="suporte">Clicando Aqui</a>
              </div>
              <!-- <div><v-btn text color="purple" :to=" {name: 'support'}">Clicando Aqui</v-btn></div> -->
            </v-card-text>
            <div align="right">
              <v-spacer />
              <v-btn outlined @click="contactMessage = false">OK</v-btn>
            </div>
          </v-card>
        </v-dialog>
        <v-card-text
          class="white--text text-center pa-0"
          style="background-color: #4b2a56"
        >
          {{ new Date().getFullYear() }} — <strong>Almeida Technologies</strong>
          <span class="ml-2" v-if="!$vuetify.breakpoint.xs"> -</span>
          <br v-if="$vuetify.breakpoint.xs" />
          <a
            style="color: white"
            text
            class="mx-3"
            small
            target="_blank"
            href="https://olhadela.digital/termos-de-uso.pdf"
          >
            Termos de Uso
          </a>
          <a
            style="color: white"
            text
            small
            target="_blank"
            href="https://olhadela.digital/politica-de-privacidade.pdf"
          >
            Política de Privacidade
          </a>
        </v-card-text>
      </v-card>
    </v-footer>
    <v-snackbar v-model="snackbar" :timeout="2000">
      Mensagem enviada para a equipe do Olhadela

      <template #action>
        <v-btn color="blue" icon @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="errorSnackbar" :timeout="4000">
      Erro ao enviar mensagem para a equipe do Olhadela

      <template #action>
        <v-btn color="error" icon @click="errorSnackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
export default {
  data: () => ({
    email: "",
    message: "",
    contactDialog: false,
    contactMessage: false,
    snackbar: false,
    errorSnackbar: false,
    loading: false,
    icons: [
      //{ icon: "mdi-phone", text: "(49) 3003-0944, ref: "tel:04930030944" },
      /* {
        icon: "mdi-email",
        text: "contato@almeidatech.com",
        ref: "mailto:contato@almeidatech.com",
      }, */
      {
        icon: "mdi-facebook",
        text: "/olhadela.digital",
        ref: "https://www.facebook.com/olhadela.digital",
      },
      {
        icon: "mdi-instagram",
        text: "@olhadela.digital",
        ref: "https://instagram.com/olhadela.digital",
      },
    ],
    items: [
      { text: "Página de Suporte", link: { name: "support" } },
      // { text: "O que é Olhadela", link: "" },
      // { text: "Quando começamos", link: "" },
    ],
  }),
  methods: {
    sendMessage() {
      if (this.$refs.contactForm.validate()) {
        this.loading = true;
        this.$axios
          .post("/message/" + this.email + "/" + this.message)
          .then(() => {
            this.snackbar = true;
            this.$refs.contactForm.reset();
            this.contactDialog = false;
          })
          .catch(() => {
            this.errorSnackbar = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>